import {
  BonusParagraph,
  CarrelloFooterVincitaInfoRow,
} from 'features/carrello/carrelloFooter/carrelloFooterVincitaInfoRow/CarrelloFooterVincitaInfoRow';
import {
  selectCombinazioniTotalizzatore,
  selectPrezzo,
  selectUnita,
} from 'features/ippica/components/ippicaTicket/ippicaTicketSelectors';
import { selectErrorLabels, selectErroriByTicket, selectIsFullCart } from 'features/carrello/carrelloSelectors';

import { CarrelloFooterSimpleInfoRow } from 'features/carrello/carrelloFooter/carrelloFooterSimpleInfoRow';
import { CostantiCalcoloIppicaTicket } from '../../ippicaTicketSlice';
import { IppicaTicketTotalizzatoreMoltiplicatore } from '../ippicaTicketTotalizzatoreMoltiplicatore';
import { MovimentiTipoScommessaEnum } from 'types/swagger';
import React from 'react';
import styles from './IppicaTicketTotalizzatoreFooter.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useTypedSelector } from 'lib/centralStore';

export type IppicaTicketTotalizzatoreFooterProps = {
  type: MovimentiTipoScommessaEnum;
};

export const IppicaTicketTotalizzatoreFooter = ({ type }: IppicaTicketTotalizzatoreFooterProps) => {
  const errori = useTypedSelector((state) => selectErroriByTicket(state, type));
  const unita = useTypedSelector(selectUnita);
  const isFullCart = useTypedSelector(selectIsFullCart);
  const errorsLabels = useTypedSelector(selectErrorLabels);
  const importoGiocato = useTypedSelector(selectPrezzo);
  const numeroCombinazioni = useTypedSelector(selectCombinazioniTotalizzatore);

  const labelWarning = useGetLabelByKey('scommetti-altro-per-bonus');

  return (
    <div className={styles.container}>
      {!isFullCart && (
        <React.Fragment>
          {/* TODO Add carrello  */}
          {/* {isMultipla ? (
            <CarrelloFooterTitleRow
              tipoCarrello={TipoCarrello.Multipla}
              numItem={numEsiti || 0}
              hasOnlyHorizontalPadding
            />
          ) : (
            descrizioneLastAvvenimentoAdded &&
            lastScommessaAdded && (
              // TODO: FIX
              <CarrelloFooterAvvenimentoInfoRow
                competitors={descrizioneLastAvvenimentoAdded}
                scommessa={{
                  tipoScommessa: lastScommessaAdded.tipoScommessa,
                  esito: lastScommessaAdded.esito,
                  quota: lastScommessaAdded.quota,
                }}
                hasOnlyHorizontalPadding
              />
            )
          )} */}
        </React.Fragment>
      )}

      <CarrelloFooterSimpleInfoRow
        label={'Combinazioni'}
        value={`${numeroCombinazioni ?? 0}`}
        hasValueFormatBase
        hasOnlyHorizontalPadding
      />

      {/** Base Scommessa come unita */}

      <CarrelloFooterSimpleInfoRow
        label={'Base Scommessa'}
        value={String(unita! / 100)}
        hasCurrency
        hasOnlyHorizontalPadding
      />

      {/** costante */}
      <CarrelloFooterSimpleInfoRow
        label={'Importo Minimo Biglietto '}
        value={String(CostantiCalcoloIppicaTicket.MinImportTotalizzatore)}
        hasCurrency
        hasOnlyHorizontalPadding
      />

      <IppicaTicketTotalizzatoreMoltiplicatore />

      {errori.messaggi.length > 0 && (
        <React.Fragment>
          {Array.from(errori.messaggi, (errore, index) => {
            const foundErrors = errorsLabels.find((errorLabel) => errorLabel.key === errore);

            if (foundErrors) {
              return <BonusParagraph key={`${foundErrors?.key}-${index}`} bonusLabel={foundErrors?.value} hasPadding />;
            } else return null;
          })}
        </React.Fragment>
      )}

      <CarrelloFooterVincitaInfoRow
        label={'Importo Giocata'}
        value={String((importoGiocato / 100).toFixed(2))}
        warningLabel={labelWarning}
        hasOnlyHorizontalPadding
      />

      {/* {isFullCart && isCarrelloTypeSport(type) && (
        <CarrelloFooterActionsRow hasOnlyHorizontalPadding>
          <CarrelloActionPrenotazione
            btnClassName={classNames({ [styles.prenotazioneBtn]: hasSettings })}
            btnLabel={labelPrenota!}
            disabled={!!isAuthenticated}
          />
          {hasSettings && (
            <CarrelloPopoverMenu>
              {isAuthenticated && (
                <button type="button" onClick={() => dispatch(toggleOpenSettings(true))}>
                  {labelImpostazioniScommessa}
                </button>
              )}
            </CarrelloPopoverMenu>
          )}
        </CarrelloFooterActionsRow>
      )} */}
    </div>
  );
};
